import type { FaireProductEntity } from "../../entity_types/product";

export const fable_home_1: FaireProductEntity = {
  token: "fable-home-1",
  type: "product",
  name: "Linen Throw Blanket",
  brandName: "Fable Home",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/4c38e4ee3cce8e1ab8ce4c00ccb9fff7264b2c9a3b219f238f775e86ea3cc12c.webp",
  priceDollars: 89,
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/4c38e4ee3cce8e1ab8ce4c00ccb9fff7264b2c9a3b219f238f775e86ea3cc12c.webp",
  weight: 2,
  dimensions: {
    width: 50,
    height: 60,
    depth: 2,
  },
  description: "Soft linen throw for the living room or bedroom.",
  categoryTokens: ["cat_accessories"],
  tags: ["linen", "home", "blanket", "textiles"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
